import React from "react";
import "./QATutorials.css";

function QATutorials() {
  return (
    <div className="qa-container">
      <h1>📘 QA Automation Tutorials</h1>
      <p className="qa-intro">
        Real-world automation framework built using <strong>MSTest</strong> and
        <strong> Page Object Model (POM)</strong>. Below is a live demonstration
        and framework overview.
      </p>

      {/* VIDEO SECTION */}
      <section className="qa-section">
        <h2>🎥 Automation Execution Demo</h2>

        <video className="qa-video" controls>
          <source src="/tutorials/mstest-run.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        <p className="qa-note">
          This video demonstrates automated test execution in Visual Studio
          using MSTest.
        </p>
      </section>

      {/* SCREENSHOTS SECTION */}
      <section className="qa-section">
        <h2>📸 Framework & Results</h2>

        <div className="qa-images">
          <img
            src="/tutorials/framework-structure.png"
            alt="Automation Framework Structure"
          />

          <img
            src="/tutorials/test-results.png"
            alt="Test Execution Results"
          />
        </div>
      </section>

      {/* EXPLANATION */}
      <section className="qa-section">
        <h2>🧠 What This Demonstrates</h2>

        <ul className="qa-list">
          <li>MSTest-based automation framework</li>
          <li>Page Object Model (POM) architecture</li>
          <li>Maintainable test design</li>
          <li>Real execution & reporting</li>
        </ul>
      </section>
    </div>
  );
}

export default QATutorials;
